import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import DevExpress from 'devextreme';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {
  _dxList: DevExpress.ui.dxList = null;
  @Input() menu: any[];
  @Output() menuIndex = new EventEmitter<number>();
  @Input() selectedItems: any[];
  @Input() title: string = this.languageService.LNG('Label.Menu');
  @Input() subTitles: string[];
  @Input() hasClassTabDetailsLeft = true;
  classTabDetailsLeft = 'tab-details-left';
  @Input() margintop = 0;
  @Input() hideTitle = false;
  @Input() selectFirst = true;
  @Input() disabled = false;
  isOpen = true;

  private menuItemIsVisited: boolean[] = [];

  //BEA spezial hæck (to be able to select ONE index from parent component)
  initialSelectedIndex = -1;
  @Input() set selectedMenuIndex(index: number) {
    if (this._dxList != null) {
      this._dxList.selectItem(index);
    }
    else {
      //the initial index may be set BEFORE the dxList-object is initialized
      this.initialSelectedIndex = index;
    }
  }
  @Output() selectedMenuIndexChange = new EventEmitter<number>();


  toolbarContent = [{
    widget: 'dxButton',
    location: 'before',
    options: {
      icon: 'menu',
      onClick: () => this.isOpen = !this.isOpen
    }
  }];

  constructor(public languageService: LanguageService) { }

  ngOnInit(): void {
    if (this.menu == null) return;

    this.menu.forEach(() => this.menuItemIsVisited.push(false));

    //when selectFirst is false, there should not be a default selected menuitem. Please don't change this!
    if (this.selectFirst) {
      if (this.menu.length > 0) {
        this.selectedItems = [this.menu[0]];
        this.menuItemIsVisited[0] = true;
      }
      if (typeof (this.selectedItems) == 'undefined' || this.selectedItems == null || this.selectedItems.length == 0) {
        if (this.menu != null && this.menu.length > 0) {
          this.selectedItems = [this.menu[0]];
          this.menuItemIsVisited[0] = true;
        }
      }
    }
    if (!this.hasClassTabDetailsLeft) {
      this.classTabDetailsLeft = '';
    }
  }

  dxListOnInit(e: any) {
    this._dxList = e.component;
    if (this.initialSelectedIndex > -1) {
      this.selectedMenuIndex = this.initialSelectedIndex;
      this.initialSelectedIndex = -1;
    }
  }

  dxListOnItemRendered(e) {
    if (typeof (e.itemData.iconColor) !== 'undefined') {
      e.itemElement.classList.add(e.itemData.iconColor);
    }
  }

  selectionChanged(e) {
    if (e.addedItems.length === 0) {
      return;
    }

    for (let i = 0; i < this.menu.length; i++) {
      if (this.menu[i] === e.addedItems[0]) {
        this.menuIndex.emit(i);
        this.selectedMenuIndexChange.emit(i);
        this.menuItemIsVisited[i] = true;
        break;
      }
    }
  }

  isMenuItemSelected(index: number): boolean {
    return this.menuItemIsVisited[index];
  }
}
